import { Form, Formik } from 'formik';
import { Modal } from '@shared/components/modals/Modal';
import { stepFormValidationSchema } from '../../constants';
import { IWorkflowStep, TStepModalFormState, TStepModalProps } from '../../types';
import { StepForm } from './StepForm';

export const StepModal = ({ handleClose, handleSubmit, isEditMode, tStepModalPositon, stepData, refreshWorflow, workflows, workflowLevel, }: TStepModalProps) => {
  const initialEditStepState: TStepModalFormState = {
    workflowId: stepData?.workflowId || '',
    displayName: stepData?.displayName || '',
    name: stepData?.name || '',
    description: stepData?.description || '',
    orderNumber: stepData?.orderNumber || 1,
    stepType: stepData?.stepType || 'Step',
    minutesAmber: stepData?.minutesAmber || 0,
    minutesGreen: stepData?.minutesGreen || 0,
    minutesRed: stepData?.minutesRed || 0,
    isDefault: stepData?.isDefault || false,
    trackerStageId: stepData?.trackerStageId || 0,
    trackerStepId: stepData?.trackerStepId || 0,
    textCommentColor: stepData?.textCommentColor || 'Black',
    isTextBold: stepData?.isTextBold || false,
    parentWorkflowStepId: stepData?.parentWorkflowStepId || null,
    reRouteWorkflowStepId: stepData?.reRouteWorkflowStepId || null,
    roleIds: stepData?.roleIds || [],
    roleIdsCanUndo: stepData?.roleIdsCanUndo || [],
    reasons: stepData?.reasons || [],
    stepPath: '',
  };

  return (
    <Modal 
      open
      hideBackdrop
      resetPosition={tStepModalPositon}
      title={isEditMode ? 'Edit Step' : 'Add New Step'}
      dialogWidth={'1000px'} 
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initialEditStepState as IWorkflowStep}
        validationSchema={stepFormValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <StepForm workflows={workflows} handleClose={handleClose} isEditMode={isEditMode} stepData={stepData} refreshWorflow={refreshWorflow} workflowLevel={workflowLevel} {...props} />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
